/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateHeadlineRequest
 */
export interface UpdateHeadlineRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateHeadlineRequest
     */
    headline: string;
}

/**
 * Check if a given object implements the UpdateHeadlineRequest interface.
 */
export function instanceOfUpdateHeadlineRequest(value: object): value is UpdateHeadlineRequest {
    if (!('headline' in value) || value['headline'] === undefined) return false;
    return true;
}

export function UpdateHeadlineRequestFromJSON(json: any): UpdateHeadlineRequest {
    return UpdateHeadlineRequestFromJSONTyped(json, false);
}

export function UpdateHeadlineRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateHeadlineRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'headline': json['headline'],
    };
}

export function UpdateHeadlineRequestToJSON(value?: UpdateHeadlineRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'headline': value['headline'],
    };
}

